import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import AssetFormBody from "../../AssetFormBody";
import AssetForm from "../AssetForm";
import Asset from "../../../../../model/asset/Asset";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import Attachment from "../../../../../model/attachment/Attachment";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {string} name new name.
	 */
	onSubmit: (asset: Asset) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * On add file
	 */
	onAddOrUpdateFile: (files: (File | Attachment)[]) => void;
}

type IState = BaseFormViewState<AssetForm>;

export default class CreateAssetFormView extends BaseFormView<AssetForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: AssetForm.createEmpty(),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<AssetFormBody form={this.state.form}
							   onFieldChange={this.onFieldChanged}
							   onFieldCompleted={this.onFieldCompleted}
							   onFocusChange={this.onFocusChange}
							   onAddOrUpdateFile={this.props.onAddOrUpdateFile}
							   onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Create asset"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit, () => {});
		});
	}
}
